import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=4bcc5ef8&scoped=true"
import script from "./portfolio.vue?vue&type=script&lang=js"
export * from "./portfolio.vue?vue&type=script&lang=js"
import style0 from "./portfolio.vue?vue&type=style&index=0&id=4bcc5ef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc5ef8",
  null
  
)

export default component.exports